/** Version 1 remains readable and reproducible for historical revisions. */
export const SCORING_METRICS_VERSION = 2;
